<template>
  <div>
<!--    <button @click="goBack" class="backbtn"><span style="color: black">⬅️ </span></button>-->
  </div>
</template>

<script>
export default {
  methods: {
    goBack() {
      this.$router.go(-1); // Go back to the previous page
    }
  }
}
</script>

<style>
.backbtn{
  font-size: 23px;
  /* width: 100px; */
  /* margin: 0px 2px; */
  border-radius: 10px;
//padding: 0px 10px;
  border: unset;
//background: #0e1133;
}
/* Add your button styling here */
</style>
